module.exports = __webpack_public_path__ + "media/images/brand/200/MARQUESBRANDINGCO LOGO MARQUESBRANDING_DESTAQUES-ec8ace84ffd483e2930bccefa03e48ec.png";